import React, { Component } from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import style from './RevenueReport.module.scss';

import Spinner from 'components/Spinner/Spinner';
import ReportSummary from './ReportSummary/ReportSummary';
import ReportTable from './ReportTable';
import RevenueForm from './RevenueForm';

import RevenueReportStore from 'stores/Report/RevenueReportStore';
import RevenueReportForm from 'stores/Forms/Reports/RevenueReportForm';

@observer
class RevenueReportPage extends Component {
  store = new RevenueReportStore();
  form = new RevenueReportForm();

  async componentDidMount() {
    await Promise.all([
      this.form.init(),
      this.store.getReport(this.form.requestParams),
    ]);
  }

  render() {
    const { report } = this.store;

    return (
      <section className={style.main}>
        {(this.store.loading || this.form.loading) && <Spinner contain />}

        <RevenueForm form={this.form} store={this.store} />

        {report && (
          <>
            <ReportSummary values={report.total} />

            <div className={style.tables}>
              {report.categories.map(it => (
                <ReportTable
                  key={it.title}
                  report={it}
                  tableStyle={classNames({
                    [style.table__single]: report.categories.length === 1,
                  })}
                />
              ))}
            </div>
          </>
        )}
      </section>
    );
  }
}

export default RevenueReportPage;
